<template>
  <div :class="{'minified': !showMenu}" class="scroll-root" ref="root">
    <div :class="{'scroll-minified': !showMenu}" class="scrollspy" v-show="showScrollSpy">
      <aside :style="asideStyle" :class="{'opened': showMenu}" class="titles">
        <nav :style="navStyle">
          <ul>
            <template v-for="(section, index) in sections">
              <li
                @click="scrollToSection(section)"
                :key="'title_' + section"
                :class="{'text-center': !showMenu, 'active': activeSection == section}"
                class="title"
              >
                <a href="javascript:void(0)">
                  <span v-show="showMenu" :ref="'title_' + section" class="title-content">
                    <slot :name="'title_' + section" :icon="icons[section]">{{index+1}}. sekcja</slot>
                  </span>
                  <span v-show="!showMenu" :ref="'icon_' + section" class="title-icon">
                    <slot :name="'icon_' + section">{{index+1}}.</slot>
                  </span>
                </a>
              </li>
            </template>
            <li class="scroll-toggle">
              <span @click="showMenu = !showMenu" class="minifyme">
                <i class="fa fa-arrow-circle-left hit"></i>
              </span>
            </li>
          </ul>
        </nav>
      </aside>
    </div>
    <div
      :class="{'scroll-minified': !showMenu, 'scroll-bordered': showScrollSpy}"
      class="scroll-content"
    >
      <template v-for="(section) in sections">
        <div :key="section" :ref="section">
          <slot :name="section" :title="titles[section]" :icon="icons[section]" />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'w-scrollspy',
  props: {
    autoHideSidebar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMenu: true,
      navStyle: {},
      toggleStyle: {},
      asideStyle: {},
      activeSection: '',
      sections: [],
      icons: [],
      titles: [],
      showScrollSpy: true
    };
  },
  methods: {
    isScrolledIntoView(elem) {
      if (!elem) return null;
      var rect = elem.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom;
      var isVisible = elemTop < window.innerHeight && elemBottom - 1 >= 0;
      return isVisible;
    },
    setAutoActiveSection() {
      let refs = this.$refs;
      for (let i = this.sections.length - 1; i >= 0; i--) {
        if (refs[this.sections[i]]) {
          let elem = refs[this.sections[i]][0];
          if (this.isScrolledIntoView(elem)) {
            this.activeSection = this.sections[i];
          }
        }
      }
    },
    setTitles() {
      for (let i = 0; i < this.sections.length; i++) {
        let section = this.sections[i];
        if (this.$refs['title_' + section]) this.$set(this.titles, section, this.$refs['title_' + section][0].cloneNode(true).innerHTML);
      }
    },
    setIcons() {
      for (let i = 0; i < this.sections.length; i++) {
        let section = this.sections[i];
        if (this.$refs['icon_' + section]) this.$set(this.icons, section, this.$refs['icon_' + section][0].cloneNode(true).innerHTML);
      }
    },
    scrollToSection(section, behavior = 'smooth') {
      let refs = this.$refs;
      refs[section][0].scrollIntoView({behavior, block: 'start'});
    },
    addScroll() {
      window.addEventListener('scroll', this.setAutoActiveSection.bind(this));
      window.addEventListener('resize', this.setAutoActiveSection.bind(this));
    },
    remScroll() {
      window.removeEventListener('scroll', this.setAutoActiveSection);
      window.removeEventListener('resize', this.setAutoActiveSection);
    }
  },
  created() {
    this.addScroll();
  },
  mounted() {
    this.sections = Object.keys(this.$scopedSlots).filter(x => x.startsWith('section') && this.$scopedSlots[x]());
    this.$nextTick(() => {
      this.setAutoActiveSection();
    });
  },
  beforeUpdate() {
    this.showScrollSpy = this.autoHideSidebar ? this.$refs.root.clientHeight > window.innerHeight : true;
    this.sections = Object.keys(this.$scopedSlots).filter(x => x.startsWith('section') && this.$scopedSlots[x]());
    this.$nextTick(() => {
      this.setIcons();
      this.setTitles();
    });
  },
  destroyed() {
    this.remScroll();
  },
  watch: {
    showMenu() {
      this.$nextTick(() => {
        this.scrollToSection(this.activeSection, 'instant');
      });
    }
  }
};
</script>
<style>
.sections {
  width: 100%;
}
.scroll-root {
  display: flex;
  width: 100%;
}
.scroll-content {
  width: calc(100% - 180px) !important;
  padding: 10px !important;
}
.scrollspy {
  max-width: 180px !important;
  padding: 0 !important;
}
.scroll-content.scroll-minified {
  width: calc(100% - 40px) !important;
}
.scrollspy.scroll-minified {
  /* width: 40px !important; */
}
.scrollspy > aside.titles {
  border-radius: 2px 0px 0px 2px;
}

.scroll-content.scroll-bordered {
  border: 1px solid #2a2725;
  border-left: 0;
  border-radius: 0px 2px 2px 0px;
}
.scrollspy > aside {
  overflow: inherit;
  position: relative;
  width: 100%;
}
.scrollspy > aside > nav {
  position: sticky;
  top: 0;
}
.scroll-toggle {
  position: relative;
  height: 34px;
}
.scroll-toggle i {
  margin-top: 4px;
}
.scroll-root:hover > tr > td.scrollspy {
  display: table-cell !important;
}
.scrollspy li.title {
  width: 100%;
}
.scrollspy li.title > a > span.title-content > * {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 150px !important;
  max-height: 100%;
  display: inline-block;
}
.scrollspy li.title > a > span.title-content:hover > * {
  white-space: normal;
  max-width: none !important;
  text-overflow: initial;
  max-height: none !important;
  overflow-x: auto;
}
.scroll-root nav > ul {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100vh;
}
.minified nav ul li.active > a:before {
  right: -11px;
}
nav ul li a {
  line-height: normal !important;
  font-size: 14px !important;
  padding: 10px 10px 10px 11px !important;
  color: #a8a8a8 !important;
  display: block !important;
  font-weight: 400 !important;
  text-decoration: none !important;
  position: relative !important;
}
.scroll-root:not(.minified) .minifyme {
  right: 0px !important;
  width: 33px !important;
}
.scroll-root:not(.minified) .minifyme:hover {
  right: 0px !important;
  width: 36px !important;
}
</style>
